(function () {
  if (window.__ljNominationForm) return;
  window.__ljNominationForm = true;

  var STORAGE_KEY = 'lj-last-form';

  function remember(source) {
    try {
      sessionStorage.setItem(STORAGE_KEY, source);
    } catch (error) {}
  }

  function lastForm() {
    try {
      return sessionStorage.getItem(STORAGE_KEY) || '';
    } catch (error) {
      return '';
    }
  }

  function hideStatus(root) {
    if (!root) return;
    root.querySelectorAll('.form-status, .form-status-list').forEach(function (el) {
      el.hidden = true;
    });
  }

  function fieldValue(form, selector) {
    var el = form.querySelector(selector);
    return el ? el.value : '';
  }

  function postToSheet(url, payload) {
    return new Promise(function (resolve) {
      var done = false;
      function finish() {
        if (done) return;
        done = true;
        resolve();
      }

      var iframe = document.createElement('iframe');
      var frameName = 'nomination-sheet-' + Date.now();
      iframe.name = frameName;
      iframe.setAttribute('hidden', '');
      iframe.setAttribute('aria-hidden', 'true');
      iframe.tabIndex = -1;
      iframe.style.display = 'none';

      var sheetForm = document.createElement('form');
      sheetForm.method = 'POST';
      sheetForm.action = url;
      sheetForm.target = frameName;
      sheetForm.acceptCharset = 'UTF-8';

      Object.keys(payload).forEach(function (key) {
        var input = document.createElement('input');
        input.type = 'hidden';
        input.name = key;
        input.value = payload[key] == null ? '' : String(payload[key]);
        sheetForm.appendChild(input);
      });

      document.body.appendChild(iframe);
      document.body.appendChild(sheetForm);

      var sentAt = Date.now();
      iframe.addEventListener('load', function () {
        if (Date.now() - sentAt < 400) return;
        finish();
      });
      setTimeout(finish, 3500);
      sheetForm.submit();
    });
  }

  function bindNominationForm(form, panel) {
    form.addEventListener(
      'submit',
      function (event) {
        remember('nomination');
        if (form.dataset.sheetDone === 'true') return;
        if (!form.checkValidity()) return;

        var url = panel.dataset.sheetUrl;
        if (!url) {
          form.dataset.sheetDone = 'true';
          return;
        }

        event.preventDefault();
        event.stopImmediatePropagation();

        var button = form.querySelector('[type="submit"]');
        if (button) button.disabled = true;

        postToSheet(url, {
          action: 'nominate',
          secret: panel.dataset.sheetSecret || '',
          name: fieldValue(form, '[data-nomination-name]'),
          email: fieldValue(form, '[data-nomination-email]'),
          message: fieldValue(form, '[data-nomination-message]'),
          page: window.location.href,
        }).then(function () {
          form.dataset.sheetDone = 'true';
          if (button) button.disabled = false;
          if (typeof form.requestSubmit === 'function') {
            form.requestSubmit();
          } else {
            HTMLFormElement.prototype.submit.call(form);
          }
        });
      },
      true
    );
  }

  function init() {
    var source = lastForm();
    if (source === 'nomination') {
      hideStatus(document.getElementById('ContactForm'));
    } else if (source === 'contact') {
      document.querySelectorAll('[data-nomination-form]').forEach(hideStatus);
    }

    var contactForm = document.getElementById('ContactForm');
    if (contactForm) {
      contactForm.addEventListener(
        'submit',
        function () {
          remember('contact');
        },
        true
      );
    }

    document.querySelectorAll('[data-nomination-form]').forEach(function (panel) {
      var form = panel.closest('form');
      if (form) bindNominationForm(form, panel);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
